import { createWebHistory, createRouter, LocationQueryValue } from 'vue-router'
import Label from '@/pages/Label.vue'
import Error from '@/pages/Error.vue'

const routes = [
    {
        // Check for legacy Fauna tokens (starts with fn)
        path: '/:token(fn.*)?',
        name: 'label-legacy',
        component: Label
    },
    {
        // Check for Supabase tokens (64 characters long hash)
        path: '/:token([0-9a-fA-F]{64})?',
        name: 'label',
        component: Label
    },
    {
        path: '/',
        name: 'label-query-param',
        component: Label
    },
    {
        path: '/error/:type?',
        name: 'error',
        component: Error
    },
    {
        path: '/:catchAll(.*)',
        redirect: '/error/notFound'
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    /**
     * Check if sd or token parameter present
     */
    const senseDataStringQueryParam: LocationQueryValue | LocationQueryValue[] = to.query.sd
    const tokenUrlParam: string | string[] = to.params.token ?? to.query.token
    if ((to.name === 'label-legacy' || to.name === 'label' || to.name === 'label-query-param') && from.query.sd) {
        // If cleaning up url just move along
        next()
    } else if (to.name === 'label-legacy' || to.name === 'label' || to.name === 'label-query-param') {
        if (!senseDataStringQueryParam && !tokenUrlParam) return next({ name: 'error' })

        if (senseDataStringQueryParam) to.meta.type = 'sd'
        if (tokenUrlParam) to.meta.type = 'token'
        next()
    } else next()
})

export default router
